<template>
  <div class="content_right_video">
    <div v-for="(item, index) in videoList"
      :class="'video_source_item_' + pageSize + '  ' + (currentVideo.name && currentVideo.name === item.name ? 'on' : '')"
      class="video_source_item">
      <template v-if="item && item.url">
        <div class="myvideo">
          <myvideo :ref="'video' + index" :source="item.url" width="100%" :cbData="'' + index"></myvideo>
        </div>
        <div class="title">
          <p class="name" :class="item.lock ? 'red' : ''">{{ item.name }} {{ item.channel_id }}</p>
        </div>
        <div class="function">
          <div class="locked" @click="lockvideo(index)" :title="item.lock ? '解锁' : '锁定'">
            <img class="icon" src="@/assets/img/locked.png" v-if="item.lock" />
            <img class="icon" src="@/assets/img/unlocked.png" v-else />
          </div>
          <div class="func">
            <img class="icon" src="@/assets/img/detail.png" />
          </div>
          <div class="func" @click="showSet(item)">
            <img alt="设置" class="icon spec" src="@/assets/img/bianji.png" />
          </div>
        </div>
      </template>
      <div class="no_video" v-else>
        <img src="@/assets/img/norecord.png" />
        <p>暂无视频</p>
      </div>
    </div>

    <div class="clear"></div>

    <SettingCmp v-if="hasSetting" :rowData="rowData" @onClose="closeSet" />
  </div>
</template>

<script>
import axios from 'axios';
import eventCommon from './eventCommon.js';
import myvideo from './../myvideo/myvideo.vue';
import SettingAreaCmp from './SettingAreaCmp';
import SettingCmp from './SettingCmp';
var lockset = new Set();
var timer = null;
export default {
  name: 'ContentRightCmp',
  components: {
    myvideo, SettingAreaCmp, SettingCmp
  },
  data() {
    return {
      videoList: [],
      page: 1,
      loading: false,
      hasAreaSetting: false,
      hasSetting: false,
      currentVideo: {},
      rowData: {},
      keyword: ''
    }
  },
  computed: {
    isLoop() {
      return this.$store.state.isLoop;
    },
    pageSize() {
      return this.$store.state.page_size;
    },
  },
  props: {
    isFS: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    isLoop(newValue, oldValue) {
      if (newValue) {
        let _this = this;
        if (timer) {
          clearInterval(timer)
        }
        timer = setInterval(function () {
          _this.getLive(_this.page);
        }, 20000);
      } else {
        clearInterval(timer);
      }
    }
  },
  mounted() {
    lockset = new Set();
    this.getLive();
    if (timer) {
      clearInterval(timer)
    }
    if (this.isLoop) {
      let _this = this;
      timer = setInterval(function () {
        _this.getLive(_this.page);
      }, 20000)
    }
    let _this = this;
    eventCommon.$on('onSelectVideo', (res) => {
      _this.doPushVideo(res);
    })
    eventCommon.$on('onShowVideoDetail', (res) => {
      this.hasSetting = false;
      _this.showSet(res);
    })
    eventCommon.$on('onSearchList', (res) => {
      let keyword = this.keyword;
      if (keyword != res) {
        this.keyword = res;
        this.getLive();
      }
    })
    eventCommon.$on('onEditDeviceName', (res) => {
      let videoList = this.videoList;
      for (let i = 0; i < videoList.length; i++) {
        if (videoList[i].device_code == res.device_code && videoList[i].channel_id == res.channel_id) {
          this.videoList[i].name = res.device_name;
          this.videoList[i].channel_name = res.channel_name;
          break;
        }
      }
    })
  },
  methods: {
    getLive(page = 1) {
      let _this = this;
      if (_this.loading) return;
      _this.loading = true;
      let keyword = _this.keyword;
      axios.get(_this.$store.state.base_url + 'Extendquery2/getProjectMonitor?page=' + page + '&keyword=' + keyword).then(function (response) {
        _this.loading = false;
        if (response.status === 200 && response.data.code == 1) {
          let list = response.data.list;
          if (list.length > 0) {
            let videoList = JSON.parse(JSON.stringify(_this.videoList));
            _this.videoList = [];
            let pageSize = parseInt(_this.pageSize);
            for (var i = 1; i <= pageSize; i++) {
              if (!lockset.has(i)) {
                if (list[i - 1]) {
                  videoList[i - 1] = list[i - 1];
                } else {
                  videoList[i - 1] = {};
                }
              }
            }
            _this.videoList = videoList;
            _this.page = page + list.length;
          } else {
            if (page > 1) {
              _this.getLive();
            } else {
              _this.videoList = [];
            }
          }
        }
      }).catch(function (error) {
        _this.loading = false;
      }).finally(function () { });
    },
    lockvideo(index) {
      index = parseInt(index);
      let videoList = JSON.parse(JSON.stringify(this.videoList));
      if (videoList[index].lock) {
        videoList[index].lock = false;
        lockset.delete(index + 1);
      } else {
        videoList[index].lock = true;
        lockset.add(index + 1);
      }
      this.videoList = videoList;
    },
    showSetArea() {
      this.hasAreaSetting = true;
    },
    showSet(item) {
      this.rowData = item;
      this.hasSetting = true;
    },
    closeSetArea() {
      this.hasAreaSetting = false;
    },
    closeSet() {
      this.hasSetting = false;
    },
    doPushVideo(item) {
      let pageSize = this.pageSize;
      let videoList = JSON.parse(JSON.stringify(this.videoList));
      for (var i = 1; i <= pageSize; i++) {
        if (!lockset.has(i)) {
          videoList[i - 1] = {
            lock: true,
            name: item.name,
            device_code: item.device_code,
            url: item.url,
            channel_id: item.channel_id,
            account: item.account,
            selected: true
          };
          lockset.add(i);
          break;
        }
      }
      this.currentVideo = item;
      this.videoList = videoList;
    }
  }
}
</script>

<style scoped>
.content_right_video {
  width: 100%;
  height: 100%;
  background: #0b1120;
  padding: 8px;
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
}

.video_source_item {
  position: relative;
  background: #0f172a;
  overflow: hidden;
  border-radius: 8px;
  border: 1px solid #1e293b;
  transition: all 0.3s ease;
}

.video_source_item:hover {
  border-color: #334155;
}

.video_source_item.on {
  border-color: #3b82f6;
  box-shadow: 0 0 0 1px rgba(59, 130, 246, 0.3), 0 0 20px rgba(59, 130, 246, 0.1);
}

.video_source_item_9 {
  width: calc(33.33% - 8px);
  height: calc(33.33% - 8px);
  margin: 4px;
}

.video_source_item_16 {
  width: calc(25% - 8px);
  height: calc(25% - 8px);
  margin: 4px;
}

.video_source_item .title {
  position: absolute;
  z-index: 2;
  top: 0;
  left: 0;
  background: rgba(15, 23, 42, 0.85);
  backdrop-filter: blur(4px);
  width: 100%;
  padding: 0 8px;
}

.video_source_item .title .name {
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 12px;
  line-height: 32px;
  color: #e2e8f0;
}

.video_source_item .title .name.red {
  color: #ef4444;
}

.video_source_item .function {
  position: absolute;
  z-index: 2;
  top: 40px;
  left: 8px;
  opacity: 0;
  transition: opacity 0.3s ease;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.video_source_item:hover .function {
  opacity: 1;
}

.video_source_item .function .locked,
.video_source_item .function .func {
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(15, 23, 42, 0.8);
  backdrop-filter: blur(4px);
  border-radius: 6px;
  cursor: pointer;
  border: 1px solid #334155;
  transition: all 0.2s ease;
}

.video_source_item .function .locked:hover,
.video_source_item .function .func:hover {
  background: rgba(59, 130, 246, 0.2);
  border-color: #3b82f6;
}

.video_source_item .function .locked .icon,
.video_source_item .function .func .icon {
  width: 14px;
  height: 14px;
}

.myvideo {
  width: 100%;
  height: 100%;
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.no_video {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.no_video img {
  width: 80px;
  opacity: 0.15;
}

.no_video p {
  font-size: 12px;
  color: #475569;
  line-height: 30px;
  margin-top: 8px;
}
</style>
